import HOC from '../HOC';
import {hacker_news} from '../utility';

let News = () => {return null;}

export default HOC(News, hacker_news);



// WEBPACK FOOTER //
// ./src/components/News/News.js